// Combined multi-concern data for the upgraded Self-Check.
// Content is taken verbatim (bilingual) from the "Bilingual Result Page Advice Library".
// This file is intentionally additive — legacy MODULES in modules.js is kept untouched.

// Concern option list shown in the primary/related concern selectors.
// IDs map to the legacy `main_concern` IDs in modules.js for backward compatibility.
export const CONCERN_OPTIONS = [
  { id: 'engorgement', zh: '乳房很胀/很硬', en: 'Breast very full / hard (engorgement)' },
  { id: 'clog',        zh: '怀疑堵奶/有硬块', en: 'Suspected clogged duct / lump' },
  { id: 'mastitis',    zh: '发烧或乳房红肿热痛', en: 'Fever or red/hot/swollen painful breast' },
  { id: 'nipple_pain', zh: '乳头痛/破皮/出血', en: 'Nipple pain / cracked / bleeding' },
  { id: 'white_spot',  zh: '乳头有白点/水泡', en: 'White spot / milk bleb' },
  { id: 'low_supply',  zh: '奶量少/奶量下降', en: 'Low milk supply / supply drop' },
  { id: 'pump_issue',  zh: '挤奶器或喇叭尺寸问题', en: 'Pump or flange-size issue' },
  { id: 'latch',       zh: '宝宝含乳/亲喂问题', en: 'Baby latch / direct feeding problem' },
  { id: 'work_pump',   zh: '回职场挤奶安排', en: 'Returning to work pumping plan' },
  { id: 'wean',        zh: '想退奶/停奶/减少奶量', en: 'Weaning / reducing milk supply' },
];

// Pairs of concerns that have conflicting goals and need explicit clarification.
export const CONFLICT_PAIRS = [
  ['low_supply', 'wean'],
];

export const GOAL_CONFIRM = {
  id: 'goal_confirmation',
  zh: '你目前的目标是增加奶量还是准备退奶？',
  en: 'Is your current goal to increase milk supply or to begin weaning?',
  options: [
    { id: 'increase', zh: '增加奶量', en: 'Increase milk supply' },
    { id: 'wean',     zh: '准备退奶 / 减少奶量', en: 'Begin weaning / reduce supply' },
    { id: 'maintain', zh: '维持目前奶量', en: 'Maintain current supply' },
  ],
};

// Compact (1-3) follow-up questions per concern. Each option resolves to a risk
// contribution: 'high' | 'medium' | 'low'. Combined risk = highest contribution
// across all answers (universal red-flags still apply on top via riskLogic.js).
//
// Red severity is reserved for genuine red flags only: confirmed fever,
// inflammatory/infection signs, or baby-safety concerns. Plain latch difficulty,
// low supply, pump/flange mismatch, ongoing nipple pain, or one-spot lumps do
// NOT auto-escalate to Red on their own — they map to Yellow ("watch closely")
// unless a universal red-flag (high fever / spreading redness / sleepy baby /
// fewer wet diapers) fires from the red-flag step.
//
// `dedup_key` is used to suppress repeating the same logical question across
// multiple concerns (e.g. asking about fever both in engorgement and clog).
// When the same key appears across concerns, SelfCheck asks it ONCE and
// propagates the same answer to every concern that needed it.
const yn = (yesRisk, noRisk = 'low') => ([
  { id: 'yes', zh: '是', en: 'Yes', risk: yesRisk },
  { id: 'no',  zh: '否', en: 'No',  risk: noRisk },
]);

export const CONCERN_FOLLOWUPS = {
  engorgement: {
    base: 'low',
    questions: [
      { id: 'fever',      dedup_key: 'fever',         zh: '是否有发烧或寒颤？',     en: 'Do you have fever or chills?',           options: yn('high') },
      { id: 'pain_worse', dedup_key: 'pain_worsening', zh: '乳房疼痛是否越来越严重？', en: 'Is breast pain getting noticeably worse?', options: yn('medium') },
      { id: 'lump',       dedup_key: 'lump_present',  zh: '是否有摸到不退的硬块？',   en: 'Do you feel a lump that does not go away?', options: yn('medium') },
    ],
  },
  clog: {
    base: 'low',
    questions: [
      { id: 'pain',        dedup_key: 'painful_area_or_lump', zh: '乳房有明显疼痛区域或硬块吗？', en: 'Do you have a clearly painful area or hard lump?', options: yn('medium') },
      { id: 'supply_drop', dedup_key: 'supply_drop_one_side', zh: '感觉某一边奶量突然下降吗？',   en: 'Did one breast suddenly produce less milk?',       options: yn('medium') },
      { id: 'fever',       dedup_key: 'fever',                zh: '是否有发烧或寒颤？',           en: 'Do you have fever or chills?',                     options: yn('high') },
    ],
  },
  mastitis: {
    // Mastitis is the one concern where ANY positive answer is a true red flag.
    base: 'medium',
    questions: [
      { id: 'fever',   dedup_key: 'fever',           zh: '是否有发烧或寒颤？',   en: 'Do you have fever or chills?',            options: yn('high') },
      { id: 'redness', dedup_key: 'spreading_redness', zh: '乳房是否有明显红肿？', en: 'Is your breast clearly red and swollen?', options: yn('high') },
      { id: 'unwell',  dedup_key: 'feeling_unwell',  zh: '是否感觉全身不舒服？', en: 'Are you feeling unwell overall?',         options: yn('high') },
    ],
  },
  nipple_pain: {
    // Nipple pain alone is NOT a red flag — at most Yellow. Only universal
    // red flags (fever, spreading redness, baby safety) can push this to Red.
    base: 'low',
    questions: [
      { id: 'continuous', dedup_key: 'nipple_pain_continuous', zh: '乳头疼痛是否持续？',   en: 'Is nipple pain continuous?',           options: yn('medium') },
      { id: 'cracked',    dedup_key: 'nipple_cracked',         zh: '乳头是否有破皮或流血？', en: 'Are your nipples cracked or bleeding?', options: yn('medium') },
      { id: 'blister',    dedup_key: 'nipple_blister',         zh: '乳头是否有水泡？',       en: 'Do you have blisters on the nipple?',  options: yn('medium') },
    ],
  },
  white_spot: {
    base: 'low',
    questions: [
      { id: 'pain',        dedup_key: 'sharp_nipple_pain_feeding', zh: '挤奶或亲喂时乳头刺痛吗？', en: 'Sharp nipple pain during feeding/pumping?',       options: yn('medium') },
      { id: 'lump',        dedup_key: 'lump_present',              zh: '是否感觉乳房有硬块？',     en: 'Do you feel a lump in the breast?',               options: yn('medium') },
      { id: 'supply_drop', dedup_key: 'supply_drop_one_side',      zh: '感觉这边的奶量突然下降吗？', en: 'Has milk output suddenly dropped on this side?',  options: yn('medium') },
    ],
  },
  low_supply: {
    // Low supply itself is NOT a red flag for the mother — it points at causes.
    // Only baby-safety red flags (from the universal red-flag step) can escalate.
    base: 'low',
    questions: [
      {
        id: 'low_supply_onset',
        dedup_key: 'low_supply_onset',
        zh: '你的奶量问题是从什么时候开始的？',
        en: 'When did your milk-supply concern begin?',
        options: [
          { id: 'low_from_start',              zh: '从生产后第一天到第一周，奶量一直比较少',   en: 'Supply has been low since the first days / first week',                risk: 'low' },
          { id: 'not_increased_after_week_two', zh: '到了第二周以后，奶量还是没有明显增加',     en: 'Supply did not noticeably increase after the second week',             risk: 'low' },
          { id: 'gradually_decreased',         zh: '原本奶量比较稳定，后来逐渐下降',           en: 'Supply was more stable before, then gradually decreased',               risk: 'low' },
          { id: 'suddenly_decreased',          zh: '原本奶量比较稳定，后来突然下降',           en: 'Supply was more stable before, then suddenly decreased',                risk: 'medium' },
          { id: 'not_sure',                    zh: '不确定',                                  en: 'Not sure',                                                              risk: 'low' },
        ],
      },
      {
        id: 'drop_subtype',
        dedup_key: 'low_supply_drop_subtype',
        // Only asked when onset = gradually_decreased OR suddenly_decreased
        condition: (answers) => {
          const o = (answers && answers.low_supply_onset) || null;
          return o === 'gradually_decreased' || o === 'suddenly_decreased';
        },
        zh: '你的奶量下降是怎样发生的？',
        en: 'How did your milk supply decrease?',
        options: [
          { id: 'sudden_one_side',  zh: '突然一边奶量明显下降',                       en: 'Sudden clear drop on one side',                            risk: 'medium' },
          { id: 'gradual_both',     zh: '两边都慢慢变少',                             en: 'Both sides gradually decreased',                            risk: 'low' },
          { id: 'after_pump_change', zh: '挤奶器换了 / 喇叭尺寸不确定后变少',         en: 'Decreased after changing pump or with uncertain flange fit', risk: 'low' },
          { id: 'after_lump_pain',  zh: '有硬块 / 疼痛后变少',                        en: 'Decreased after a lump or pain appeared',                   risk: 'medium' },
          { id: 'not_sure',         zh: '不确定',                                     en: 'Not sure',                                                  risk: 'low' },
        ],
      },
      { id: 'blockage',    dedup_key: 'has_blockage_or_lump', zh: '乳房有硬块或堵奶吗？',         en: 'Any lumps or blocked milk flow?',           options: yn('medium') },
      { id: 'pump_issue',  dedup_key: 'pump_or_flange_issue', zh: '挤奶器或喇叭尺寸有问题吗？',   en: 'Any pump or flange-size issue?',            options: yn('medium') },
      { id: 'latch_issue', dedup_key: 'latch_or_suck_issue',  zh: '宝宝含乳或吸吮效率有问题吗？', en: 'Any baby latch or sucking-efficiency issue?', options: yn('medium') },
    ],
  },
  pump_issue: {
    base: 'low',
    questions: [
      { id: 'pain',       dedup_key: 'nipple_pain_pumping',  zh: '挤奶或亲喂时乳头疼痛吗？',     en: 'Nipple pain when pumping or latching?',         options: yn('medium') },
      { id: 'white',      dedup_key: 'nipple_whitening',     zh: '乳头有发白、变形或起水泡吗？', en: 'Nipple turning white, misshapen or blistered?', options: yn('medium') },
      { id: 'efficiency', dedup_key: 'pump_efficiency_poor', zh: '感觉挤奶效率差，排不空吗？',   en: 'Poor pumping efficiency, not emptying well?',   options: yn('medium') },
    ],
  },
  latch: {
    base: 'low',
    questions: [
      { id: 'pain',       dedup_key: 'nipple_pain_feeding',    zh: '亲喂时乳头疼痛吗？',         en: 'Nipple pain during direct latch?',         options: yn('medium') },
      { id: 'baby_cry',   dedup_key: 'baby_fussy_at_breast',   zh: '宝宝亲喂时容易哭闹或烦躁吗？', en: 'Does baby cry or fuss at the breast?',     options: yn('medium') },
      { id: 'baby_sleep', dedup_key: 'baby_short_sleep_after', zh: '宝宝亲喂后睡得很短吗？',     en: 'Does baby sleep only briefly after feeds?', options: yn('medium') },
    ],
  },
  work_pump: {
    base: 'low',
    questions: [
      { id: 'pain', dedup_key: 'pain_when_pumping', zh: '挤奶时是否会感到疼痛？', en: 'Do you feel pain when pumping?', options: yn('medium') },
    ],
  },
  wean: {
    base: 'low',
    questions: [
      { id: 'pain',  dedup_key: 'breast_pain_during_weaning', zh: '退奶过程中是否感到明显涨痛或硬块？', en: 'Significant fullness, pain or lumps while weaning?', options: yn('medium') },
      { id: 'fever', dedup_key: 'fever',                      zh: '退奶过程中是否有发烧或红肿？',       en: 'Fever or redness while weaning?',                    options: yn('high') },
    ],
  },
};

// Combined result content per concern (verbatim from advice library).
// Sections: title, why, what_to_do, observe (optional), when_to_seek (optional),
// extra (optional list of {title, items}), helpful_tools (CTA labels).
export const CONCERN_RESULTS = {
  engorgement: {
    title_zh: '你的情况比较像生理性涨奶',
    title_en: 'Your situation looks like early physiological engorgement',
    why_zh: '产后初期，尤其是第 3-5 天左右，荷尔蒙会比较活跃，奶水开始明显上来。如果宝宝还没有很有效含乳，或乳房里的奶水没有规律移出，就容易出现涨、硬、紧、腋下胀，甚至摸到硬块。这个阶段很多妈妈都会遇到，不代表你做错了。',
    why_en: 'In the early postpartum days, especially around day 3-5, your hormones are very active and milk production starts to increase. If baby is not latching effectively yet, or milk is not removed regularly, the breast may feel full, tight, hard, or swollen, sometimes even around the armpit. This is common and does not mean you are doing anything wrong.',
    what_to_do_zh: [
      '每 2-3 小时安排一次亲喂、手挤或挤奶。',
      '如果宝宝可以含乳，先让宝宝亲喂，每边约 15-20 分钟，不需要强迫超过 30 分钟。',
      '如果宝宝含乳困难或含乳很痛，先用手挤奶把一部分奶水排出来，让乳房软一点。',
      '当奶流开始比较顺，或一次能收集到约 15ml 以上，可以开始使用挤奶器。',
      '初期使用挤奶器要先量乳头尺寸，用合适喇叭 / insert，从按摩模式和低吸力开始。',
      '亲喂、手挤或挤奶后，冷敷 10-15 分钟。',
      '这个阶段目标是舒缓和维持流动，不是一次把乳房挤到很空。',
    ],
    what_to_do_en: [
      'Remove milk every 2-3 hours by direct latch, hand expression, or pumping.',
      'If baby can latch, offer the breast first. Aim for about 15-20 minutes each side, without forcing more than 30 minutes.',
      'If baby cannot latch well or latching is painful, hand express some milk first to soften the breast.',
      'Once milk flow becomes smoother, or you can collect around 15ml or more, you may start using a breast pump.',
      'For early pumping, measure nipple size first, use the correct flange/insert, and start with massage mode and low suction.',
      'Apply cold compress for 10-15 minutes after feeding, hand expression, or pumping.',
      'The goal is to feel more comfortable and keep milk flowing, not to empty the breast aggressively.',
    ],
    observe_zh: [
      '大多数生理性涨奶会在 1-2 天慢慢舒缓。',
      '如果腋下也涨，通常是乳腺组织或前方排出不顺造成，前面乳房流动改善后会慢慢缓解。',
      '如果越挤越涨，可能是刺激过多，需要调整方式。',
    ],
    observe_en: [
      'Most early engorgement improves gradually within 1-2 days.',
      'If the armpit area is swollen, it may be related to breast tissue fullness or poor milk flow from the front breast. It usually improves as milk flow improves.',
      'If the breast becomes fuller after frequent pumping, there may be overstimulation and the plan may need adjustment.',
    ],
    when_to_seek_zh: ['如果出现发烧、寒颤、红肿扩散、越来越痛、硬块不退、宝宝尿量减少或拒喝，请尽快寻求医生或泌乳顾问协助。'],
    when_to_seek_en: ['Seek medical or lactation support promptly if you develop fever, chills, spreading redness, worsening pain, a lump that does not improve, or if baby has fewer wet diapers or refuses feeds.'],
    helpful_tools_zh: ['预约无痛泌乳 / 乳房检查', '观看手挤奶教学', '预约 video call 评估'],
    helpful_tools_en: ['Book painless lactation treatment / breast assessment', 'Watch hand expression video', 'Book video consultation'],
  },
  clog: {
    title_zh: '你的情况可能和堵奶或乳汁排出不顺有关',
    title_en: 'Your symptoms may be related to blocked milk flow or a hard lump',
    why_zh: '如果乳房某个位置有硬块、疼痛，或某一边奶量突然下降，常见原因包括宝宝吸吮不够有效、挤奶器排空不理想、喇叭尺寸不合适、泵配件没有装好，或乳汁流动被局部阻塞。',
    why_en: 'If you feel a hard lump, pain in one area, or a sudden drop in milk from one breast, possible causes include ineffective latch, poor milk removal, wrong flange size, pump parts not fitted properly, or a local blockage in milk flow.',
    what_to_do_zh: [
      '继续规律排奶，不要突然停奶。',
      '先检查挤奶器配件有没有装好、阀门 / 膜片有没有松或损坏。',
      '挤奶后可以用手挤辅助，把剩余奶水轻柔排出。',
      '如果宝宝愿意，鼓励亲喂，因为宝宝吸吮有时比挤奶器更有效。',
      '不要用力按压硬块，也不要做很痛的按摩。',
      '排奶后冷敷 10-15 分钟，帮助舒缓肿胀和疼痛。',
    ],
    what_to_do_en: [
      'Keep removing milk regularly; do not suddenly stop.',
      'Check pump parts, valves, membranes, and assembly.',
      'After pumping, use gentle hand expression to help remove remaining milk.',
      'If baby is willing, direct latch may help because baby can sometimes remove milk better than a pump.',
      'Avoid forceful pressing or painful massage on the lump.',
      'Apply cold compress for 10-15 minutes after milk removal to reduce swelling and discomfort.',
    ],
    observe_zh: [
      '如果硬块在 24 小时内变小、疼痛下降，通常代表方向正确。',
      '如果奶量突然下降，也要同时检查泵和喇叭，不一定只是少奶。',
    ],
    observe_en: [
      'If the lump becomes smaller and pain reduces within 24 hours, the plan is likely helping.',
      'If milk output suddenly drops, also check the pump and flange; it is not always true low supply.',
    ],
    when_to_seek_zh: ['如果有发烧、红肿扩散、硬块越来越痛、超过 24-48 小时没有改善，建议尽快预约乳房检查或咨询医生。'],
    when_to_seek_en: ['If fever, spreading redness, worsening pain, or no improvement after 24-48 hours occurs, book a breast assessment or consult a doctor promptly.'],
    helpful_tools_zh: ['预约无痛泌乳疏通', '检查挤奶器和喇叭尺寸', '发送结果给 WhatsApp'],
    helpful_tools_en: ['Book painless lactation treatment', 'Check pump and flange fit', 'Send result to WhatsApp'],
  },
  mastitis: {
    title_zh: '你的情况有乳房发炎或乳腺炎风险',
    title_en: 'Your symptoms may suggest breast inflammation or mastitis risk',
    why_zh: '当乳房疼痛伴随发烧、寒颤、明显红肿或全身不舒服时，可能不只是普通堵奶，而是乳房组织发炎或感染风险。泌乳处理可以协助排乳、舒缓乳房张力和维持乳汁流动，但不能代替医生诊断和药物治疗。',
    why_en: 'When breast pain comes with fever, chills, obvious redness, swelling, or feeling unwell, it may be more than a simple blocked duct. It may suggest breast inflammation or infection risk. Lactation support can help improve milk flow and relieve breast tension, but it does not replace medical diagnosis or medication.',
    what_to_do_zh: [
      '如果发烧或全身不舒服，请联系医生评估。',
      '继续规律移出奶水，避免完全不排奶。',
      '不要用力按压或做很痛的按摩。',
      '可以冷敷舒缓疼痛和肿胀。',
      '如果医生判断有感染，可能需要抗生素或其他药物治疗。',
      '可同时预约泌乳顾问做乳房检查和排乳指导，帮助恢复流动、减少奶量下降。',
    ],
    what_to_do_en: [
      'If you have fever or feel unwell, contact a doctor for assessment.',
      'Continue regular milk removal; avoid stopping completely.',
      'Avoid forceful or painful massage.',
      'Use cold compress to ease pain and swelling.',
      'If a doctor suspects infection, antibiotics or medication may be needed.',
      'You may also book a lactation consultant for breast assessment and milk removal guidance to support recovery and protect supply.',
    ],
    when_to_seek_zh: ['发烧、寒颤、红肿扩散、疼痛快速加重、乳房出现脓肿感、宝宝明显喝少或尿量减少，请尽快就医。'],
    when_to_seek_en: ['Seek urgent care if you have fever, chills, spreading redness, rapidly worsening pain, possible abscess, or if baby is feeding poorly or has fewer wet diapers.'],
    helpful_tools_zh: ['尽快预约乳房检查', '同时咨询医生', '发送 WhatsApp 给顾问'],
    helpful_tools_en: ['Book breast assessment urgently', 'Consult a doctor', 'Send WhatsApp summary'],
  },
  nipple_pain: {
    title_zh: '你的乳头疼痛可能和含乳、喇叭尺寸或吸力有关',
    title_en: 'Your nipple pain may be related to latch, flange size, or suction',
    why_zh: '乳头疼痛不一定只是"正常适应"。常见原因包括宝宝含乳太浅、挤奶器吸力太强、喇叭太大或太小、乳头本身充血或卡奶，或挤奶时间过长。如果乳头已经破皮或流血，继续强吸可能会让伤口更严重。',
    why_en: 'Nipple pain is not always "normal adjustment". Common causes include shallow latch, pump suction that is too strong, flange size that is too big or too small, nipple engorgement or blocked milk near the nipple, or pumping for too long. If the nipple is cracked or bleeding, strong suction may worsen the injury.',
    what_to_do_zh: [
      '如果亲喂痛，先检查宝宝含乳是否够深，是否 tummy to tummy、nipple to nose、头微微后仰。',
      '如果挤奶前就痛，可能乳头乳晕太硬或卡奶，可先轻柔按摩乳头乳晕，再短暂温敷乳头位置。',
      '如果挤奶时痛，先降低吸力，必要时只用 massage mode。',
      '如果挤奶后痛，常见是吸力太强、尺寸不对或挤太久。',
      '很痛时不要硬撑，挤奶 15 分钟后可改用手挤把乳房排到松软。',
      '有破皮时要保持清洁干爽，并避免继续摩擦伤口。',
    ],
    what_to_do_en: [
      'If direct latch is painful, check if baby has a deep latch with tummy-to-tummy position, nipple-to-nose approach, and slight head tilt.',
      'If pain happens before pumping, the nipple/areola may be hard or congested. Gently massage the nipple and areola first, and use brief warmth over the nipple area if needed.',
      'If pain happens during pumping, reduce suction. Use massage mode only if needed.',
      'If pain happens after pumping, common causes are strong suction, wrong flange size, or pumping too long.',
      'If it is very painful, do not force it. Pump for about 15 minutes, then hand express until the breast feels softer.',
      'If there is cracked skin, keep it clean and dry, and avoid further friction.',
    ],
    when_to_seek_zh: ['如果乳头持续破皮流血、疼痛越来越严重、有水泡、乳头变白后很痛、或宝宝无法含乳，请尽快找泌乳顾问评估。若有感染迹象，请看医生。'],
    when_to_seek_en: ['Seek lactation support if nipples remain cracked or bleeding, pain worsens, blisters appear, nipples turn white with pain, or baby cannot latch. See a doctor if there are signs of infection.'],
    helpful_tools_zh: ['预约含乳姿势评估', '检查喇叭尺寸', '观看手挤奶教学'],
    helpful_tools_en: ['Book latch assessment', 'Check flange size', 'Watch hand expression guide'],
  },
  white_spot: {
    title_zh: '你的情况可能和小白点或乳头出口阻塞有关',
    title_en: 'Your symptoms may be related to a nipple bleb or blocked nipple opening',
    why_zh: '小白点通常是乳头出口被奶脂、皮肤薄膜或局部阻塞卡住，导致后方乳汁排不出来。妈妈可能会觉得某一边突然奶量变少、乳房有硬块、挤奶或亲喂时刺痛，甚至越挤越不顺。',
    why_en: 'A nipple bleb or white spot can happen when a nipple opening is blocked by thick milk, skin, or local debris. Milk behind that opening may not flow well. You may notice sudden lower output from one breast, a hard lump, sharp pain during feeding or pumping, or milk that does not flow smoothly.',
    what_to_do_zh: [
      '堵的那一边维持约每 3 小时排奶一次。',
      '挤奶后加手挤 15 分钟，重点放在乳头和乳晕位置；后方硬块只需要另一只手轻轻支撑，不要大力按压。',
      '如果宝宝愿意亲喂，可以多让宝宝吸，因为宝宝有时比挤奶器更有效。',
      '可以使用 Haakaa + Epsom salt 浸泡乳头，再配合手挤奶。',
      '做完后冷敷，不建议持续温敷。',
      '可以配合手挤奶教学视频练习。',
    ],
    what_to_do_en: [
      'Continue milk removal on the affected side about every 3 hours.',
      'After pumping, add 15 minutes of hand expression, focusing on the nipple and areola area. Support the back lump gently with the other hand; do not press hard.',
      'If baby can latch, offer the affected breast, as baby may remove milk more effectively than a pump.',
      'You may use the Haakaa + Epsom salt soaking method, then follow with hand expression.',
      'Apply cold compress afterwards; avoid continuous heat.',
      'Practise with a hand-expression teaching video if available.',
    ],
    extra_zh: [
      {
        title: 'Epsom salt 浸泡方法',
        items: [
          'Haakaa 方法：用温水加入约 1 tablespoon 无香精 Epsom salt，装入 Haakaa 后轻轻吸附在乳房上，浸泡 10-15 分钟。',
          '碗浸泡方法：用非常温但不烫的水，把乳头和乳晕浸泡 5-10 分钟。',
          '浸泡后要用清水冲洗乳头，再亲喂或挤奶。',
          '一天最多 2-3 次，每次不要超过 10-15 分钟。',
        ],
      },
      {
        title: '为什么用 Epsom salt，不用 rock salt / sea salt',
        items: [
          'Epsom salt 是 magnesium sulphate，常用于浸泡舒缓。它的高渗透特性可以帮助软化局部皮肤、舒缓肿胀和疼痛感。',
          'Rock salt 或 sea salt 主要是 sodium chloride，作用不同，也比较容易刺激皮肤，所以不建议替代。',
        ],
      },
    ],
    extra_en: [
      {
        title: 'Epsom Salt Soaking Method',
        items: [
          'Haakaa method: Add about 1 tablespoon of plain, unscented Epsom salt to warm water, place it in the Haakaa, and gently attach it to the breast for 10-15 minutes.',
          'Bowl method: Use very warm, not scalding, water and soak the nipple and areola for 5-10 minutes.',
          'Rinse the nipple with plain water before nursing or pumping.',
          'Limit to 2-3 times per day, no more than 10-15 minutes each time.',
        ],
      },
      {
        title: 'Why Epsom salt, not rock salt or sea salt',
        items: [
          'Epsom salt is magnesium sulphate and is commonly used for soaking. Its hypertonic effect may help soften the local skin and ease swelling or discomfort.',
          'Rock salt or sea salt is mainly sodium chloride, works differently, and may irritate the skin, so it is not recommended as a replacement.',
        ],
      },
    ],
    when_to_seek_zh: ['如果小白点反复出现、硬块不退、疼痛明显、乳头破皮流血、发烧或红肿扩散，请预约泌乳顾问或医生评估。'],
    when_to_seek_en: ['Seek support if the bleb keeps returning, the lump does not improve, pain is significant, nipples are cracked or bleeding, or fever/spreading redness appears.'],
    helpful_tools_zh: ['观看手挤奶视频', '预约小白点 / 堵奶处理', '咨询 sunflower lecithin 是否适合'],
    helpful_tools_en: ['Watch hand expression video', 'Book nipple bleb / blocked duct support', 'Ask whether sunflower lecithin is suitable'],
  },
  low_supply: {
    title_zh: '你的情况可能需要先找出奶量不足的原因',
    title_en: 'Your situation may need a supply check before increasing milk',
    why_zh: '奶量少不一定只是身体不够奶。常见原因包括排奶次数不足、宝宝吸吮效率低、挤奶器或喇叭不合适、乳房有堵塞、或产后初期乳腺还没有完全通畅。尤其产后前 7-10 天，不建议一味催奶，先确保乳汁可以顺利排出比较重要。',
    why_en: 'Low supply is not always because your body cannot make enough milk. Common causes include not removing milk often enough, ineffective latch, unsuitable pump or flange, blocked milk flow, or early postpartum breast congestion. In the first 7-10 days, it is usually better to make sure milk can flow well before aggressively boosting supply.',
    what_to_do_zh: [
      '先确认乳房有没有硬块、堵奶或排空不顺。',
      '亲喂或挤奶维持一天 8-12 次，尤其初期要规律。',
      '挤奶时可在挤奶前短暂温敷，帮助 let-down；挤完如果涨痛则冷敷。',
      '产后一周后，如果乳腺通畅，可连续 7 天在晚上 11pm-2am 之间做 power pumping。',
      '可以增加亲喂次数，宝宝有效吸吮是很好的刺激。',
      'Milk booster、fenugreek、moringa 或催奶食物可作为辅助，但不是每个人都有效。',
    ],
    what_to_do_en: [
      'First check for lumps, blocked flow, or poor breast drainage.',
      'Aim for 8-12 milk removals per day by latch or pumping, especially in the early weeks.',
      'Before pumping, short warm compress may help let-down; after pumping, use cold compress if swollen or painful.',
      'After the first week, if milk flow is clear, you may try power pumping for 7 consecutive days, ideally between 11pm-2am.',
      'Increase effective direct latching when possible; baby\u2019s suckling is a strong stimulation.',
      'Milk boosters such as fenugreek, moringa, or lactation foods may support some mothers, but they do not work for everyone.',
    ],
    observe_zh: [
      '奶量突然下降时，要先检查堵奶和泵问题。',
      '如果吃很多催奶食物但乳汁排不出来，反而可能增加堵奶和乳腺炎风险。',
    ],
    observe_en: [
      'If supply suddenly drops, check for blocked ducts and pump issues first.',
      'Taking many milk boosters while milk cannot flow out may increase the risk of blocked ducts or mastitis.',
    ],
    helpful_tools_zh: ['预约追奶评估', '检查乳房和挤奶器', '一个月哺乳陪跑'],
    helpful_tools_en: ['Book supply assessment', 'Check breast and pump setup', 'One-month breastfeeding coaching'],
  },
  pump_issue: {
    title_zh: '你的问题可能和挤奶器或喇叭尺寸有关',
    title_en: 'Your issue may be related to pump setup or flange size',
    why_zh: '不合适的喇叭尺寸、太强吸力、泵配件安装不正确，或不适合现阶段的挤奶器，都可能造成乳头疼痛、乳头变白、乳晕被过度拉入、排空差，甚至奶量下降。',
    why_en: 'Wrong flange size, suction that is too strong, pump parts not fitted properly, or a pump that does not suit your current stage may cause nipple pain, whitening, swelling, areola being pulled in too much, poor milk removal, or lower output.',
    what_to_do_zh: [
      '重新量乳头尺寸，再选择合适 flange 或 insert。',
      '如果乳头疼痛、变白、变形或摩擦，先降低吸力。',
      '初期建议从按摩模式、低吸力 level 1-2 开始。',
      '每次挤奶约 20-30 分钟即可，不一定越久越好。',
      '检查阀门、膜片、喇叭和接头是否装好或损坏。',
      '产后初期，如果 handsfree 效果不好，可考虑手扶式或手挤辅助。',
    ],
    what_to_do_en: [
      'Measure nipple size again and choose the correct flange or insert.',
      'If nipples are painful, white, misshapen, or rubbing, lower suction first.',
      'In the early stage, start with massage mode and low suction level 1-2.',
      'Pumping 20-30 minutes per session is usually enough; longer is not always better.',
      'Check valves, membranes, flange, and connectors for poor fitting or damage.',
      'In early postpartum, if handsfree pumping is not effective, consider a handheld pump setup or hand expression support.',
    ],
    helpful_tools_zh: ['预约喇叭尺寸检查', '咨询挤奶器租借 / 购买', '上传 / 发送目前挤奶器照片给顾问'],
    helpful_tools_en: ['Book flange-size check', 'Ask about pump rental/purchase', 'Send current pump photo to consultant'],
  },
  latch: {
    title_zh: '你和宝宝可能需要含乳和亲喂姿势指导',
    title_en: 'You and baby may need latch and positioning support',
    why_zh: '如果宝宝含乳困难、吸一下就哭、亲喂后睡很短、乳头疼痛或受伤，常见原因包括姿势不够贴近、宝宝没有含到足够乳晕、乳房太硬、奶流太快 / 太慢，或宝宝吸吮效率需要进一步评估。',
    why_en: 'If baby struggles to latch, cries at the breast, sleeps only briefly after feeds, or your nipples are painful or injured, possible reasons include positioning, shallow latch, breast hardness, milk flow being too fast or too slow, or baby\u2019s sucking efficiency needing assessment.',
    what_to_do_zh: [
      '让宝宝身体贴近妈妈，tummy to tummy。',
      '乳头对准宝宝鼻子或上唇，让宝宝头微微后仰。',
      '等宝宝张大嘴，再让下巴先靠近乳房。',
      '如果乳房太硬，先手挤一点奶，让乳晕变软。',
      '白天可多练习亲喂，晚上如果妈妈太累，可挤奶后补 EBM 或配方奶，由妈妈和医生 / 顾问依据宝宝情况决定。',
      '如果怀疑舌系带、体重增长不理想或宝宝喝不够，建议找有经验的泌乳顾问或医生评估。',
    ],
    what_to_do_en: [
      'Keep baby close, tummy to tummy.',
      'Aim nipple toward baby\u2019s nose or upper lip, allowing baby\u2019s head to tilt slightly back.',
      'Wait for a wide mouth, then bring baby in chin-first.',
      'If the breast is too hard, hand express a little first to soften the breast.',
      'Practise direct latch more during the day. At night, if mother is too tired, expressed milk or formula top-up can be considered based on baby\u2019s needs and professional advice.',
      'If tongue tie, poor weight gain, or poor intake is suspected, seek assessment from an experienced lactation consultant or doctor.',
    ],
    observe_zh: [
      '宝宝亲喂后睡比较短，不一定代表完全失败，但要一起看尿布、体重、吞咽声和精神。',
      '亲喂有效时，妈妈通常会感觉乳房变软，宝宝有吞咽声，喂后比较满足。',
    ],
    observe_en: [
      'Baby sleeping for a shorter time after direct latch does not always mean failure, but wet diapers, weight gain, swallowing sounds, and alertness matter.',
      'With effective feeding, the breast usually softens, swallowing can be heard, and baby seems more settled after feeding.',
    ],
    when_to_seek_zh: ['如果宝宝尿量减少、嗜睡、拒喝、体重增长不理想、黄疸加重，或妈妈乳头持续破皮流血，请尽快咨询医生或专业泌乳顾问。'],
    when_to_seek_en: ['Seek help promptly if baby has fewer wet diapers, is sleepy, refuses feeds, has poor weight gain, worsening jaundice, or if mother has persistent cracked or bleeding nipples.'],
    helpful_tools_zh: ['预约亲喂姿势评估', '预约 video call 含乳指导', '查看含乳姿势图片教学'],
    helpful_tools_en: ['Book latch assessment', 'Book video call latch coaching', 'View latch positioning guide'],
  },
  work_pump: {
    title_zh: '你可以开始建立回职场挤奶节奏',
    title_en: 'You can start preparing your back-to-work pumping routine',
    why_zh: '回职场前不要突然把挤奶时间拉很长。比较安全的方式是循序渐进，让身体慢慢适应固定排奶时间，这样对奶量影响比较小，也比较不容易堵奶。',
    why_en: 'Before returning to work, avoid suddenly stretching long hours between milk removal. A gradual routine helps your body adjust, protects milk supply, and reduces the chance of engorgement or blocked ducts.',
    what_to_do_zh: [
      '如果现在每 3 小时挤一次，可以先改成 3.5 小时一次。',
      '身体适应 3-5 天，没有明显涨痛或奶量下降，再慢慢调整到 4 小时一次。',
      '上班前 14-7 天，练习白天固定时间排奶。',
      '上班前 7 天，模拟真实上班节奏，例如 10am / 2pm / 5pm 挤奶。',
      '上班前一定要排奶一次，回家后尽量多亲喂。',
      '晚上睡前可再排奶一次，帮助维持奶量。',
    ],
    what_to_do_en: [
      'If you currently pump every 3 hours, first try every 3.5 hours.',
      'After 3-5 days with no obvious breast pain or supply drop, slowly adjust to every 4 hours.',
      'From 14-7 days before work, practise fixed daytime milk removal.',
      'During the last 7 days before work, simulate your workday schedule, for example 10am / 2pm / 5pm.',
      'Remove milk before leaving for work, and direct latch more after returning home.',
      'Pump once before bedtime if needed to help maintain supply.',
    ],
    extra_zh: [
      {
        title: '范例时间表',
        items: [
          '6-7am：亲喂或挤奶',
          '10am / 10.30am：挤奶',
          '1.30-2pm：挤奶',
          '5pm：挤奶',
          '8pm：亲喂或挤奶',
          '11pm：睡前挤奶',
        ],
      },
      {
        title: '关键原则',
        items: [
          '一天尽量保持 6-8 次排奶，包含亲喂和挤奶。',
          '白天间隔约 3-4 小时。',
          '尽量不要超过 5 小时完全没有排奶。',
          '回家后多亲喂，有助维持奶量。',
        ],
      },
    ],
    extra_en: [
      {
        title: 'Sample Schedule',
        items: [
          '6-7am: direct latch or pump',
          '10am / 10.30am: pump',
          '1.30-2pm: pump',
          '5pm: pump',
          '8pm: direct latch or pump',
          '11pm: bedtime pump',
        ],
      },
      {
        title: 'Key Principles',
        items: [
          'Aim for 6-8 milk removals per day, including direct latch and pumping.',
          'Keep daytime intervals around 3-4 hours.',
          'Try not to go more than 5 hours with no milk removal.',
          'Direct latch more after work to help maintain supply.',
        ],
      },
    ],
    when_to_seek_zh: ['如果出现明显涨痛、硬块、或奶量突然明显下降，把间隔稍微拉近一点，等稳定后再慢慢调整。'],
    when_to_seek_en: ['If you develop breast pain, lumps, or sudden supply drop, shorten the interval slightly and adjust again only after things stabilise.'],
    helpful_tools_zh: ['预约回职场挤奶计划', '一个月哺乳陪跑', '查看母乳保存和清洗消毒教学'],
    helpful_tools_en: ['Book return-to-work pumping plan', 'One-month breastfeeding coaching', 'View milk storage and pump cleaning guide'],
  },
  wean: {
    title_zh: '你可以用循序渐进的方式退奶或减少奶量',
    title_en: 'You can reduce milk supply gradually and more safely',
    why_zh: '退奶不建议突然停挤或停喂，因为乳房一下子太满，容易涨痛、堵奶，甚至发炎。比较安全的方式是慢慢拉长时间，让身体知道需要减少奶量。',
    why_en: 'Suddenly stopping breastfeeding or pumping can cause breast fullness, pain, blocked ducts, or inflammation. A gradual approach helps your body understand that less milk is needed.',
    what_to_do_zh: [
      '如果现在每 3 小时挤一次，先尝试 3.5 小时一次。',
      '身体适应 3-5 天，没有明显涨痛，再慢慢调整到 4 小时一次。',
      '每次只排到舒服，不需要挤到很空。',
      '挤完后冷敷 10-15 分钟，帮助降低回填速度。',
      '少吃明显发奶食物，例如大量汤水、催奶补品或 milk booster。',
      '可参考退奶食物，例如包菜、韭菜、人参、山楂、麦芽等，但效果因人而异。',
    ],
    what_to_do_en: [
      'If you currently pump every 3 hours, first try every 3.5 hours.',
      'After 3-5 days with no obvious pain, slowly adjust to every 4 hours.',
      'Express only until comfortable; you do not need to empty fully.',
      'Apply cold compress for 10-15 minutes after milk removal.',
      'Reduce strong lactation foods, large soup intake, milk boosters, or supplements.',
      'Some mothers use weaning-support foods such as cabbage, chives, ginseng, hawthorn, or malt, but response differs for each person.',
    ],
    extra_zh: [
      {
        title: '中草药 / 食物辅助',
        items: [
          '如果想使用退奶茶或中草药配方，建议先确认自己没有药物禁忌、过敏、怀孕、慢性疾病或正在服药。',
          '退奶茶可作为辅助，不应该取代乳房观察和规律调整。',
        ],
      },
      {
        title: '退奶药物提醒',
        items: [
          '如果需要快速退奶或身体情况不适合慢慢调整，退奶药必须由医生评估和开立，不建议自行购买服用。',
        ],
      },
    ],
    extra_en: [
      {
        title: 'Herbal or Food Support',
        items: [
          'If you plan to use weaning tea or herbal support, check that you have no medication restrictions, allergies, pregnancy, chronic illness, or ongoing medication concerns.',
          'Herbal support is only an aid and should not replace breast monitoring and gradual adjustment.',
        ],
      },
      {
        title: 'Medication Reminder',
        items: [
          'If you need rapid weaning or cannot reduce supply gradually, medication must be assessed and prescribed by a doctor. Do not self-medicate.',
        ],
      },
    ],
    when_to_seek_zh: ['如果退奶过程中出现明显涨痛、硬块、发烧或红肿，请先不要继续拉长时间，回到原本较短间隔，并尽快咨询。'],
    when_to_seek_en: ['If you develop strong breast pain, lumps, fever, or redness during weaning, stop stretching the interval, return to a shorter interval, and seek support promptly.'],
    helpful_tools_zh: ['预约退奶计划', '预约乳房检查', 'WhatsApp 顾问确认是否适合退奶茶 / 退奶药'],
    helpful_tools_en: ['Book weaning plan', 'Book breast assessment', 'WhatsApp consultant to check if herbal or medication support is suitable'],
  },
};

// Map risk severity ordering
const RISK_ORDER = { low: 0, medium: 1, high: 2 };

// Severity contribution of answering a single concern's follow-ups.
export const computeConcernRisk = (concernId, answers = {}) => {
  const def = CONCERN_FOLLOWUPS[concernId];
  if (!def) return 'low';
  let max = def.base || 'low';
  for (const q of def.questions) {
    const ans = answers[q.id];
    if (!ans) continue;
    const opt = q.options.find((o) => o.id === ans);
    if (!opt) continue;
    if (RISK_ORDER[opt.risk] > RISK_ORDER[max]) max = opt.risk;
  }
  return max;
};

// Map low/medium/high → green/yellow/red used elsewhere in the app.
export const severityToRisk = (sev) => (sev === 'high' ? 'red' : sev === 'medium' ? 'yellow' : 'green');

// Get all concern ids the user picked (primary first then related).
export const getAllConcernIds = (submission) => {
  if (!submission) return [];
  const primary = submission.primary_concern || submission.main_concern;
  const related = Array.isArray(submission.related_concerns) ? submission.related_concerns : [];
  const all = [];
  if (primary) all.push(primary);
  for (const r of related) {
    if (r && r !== primary && !all.includes(r)) all.push(r);
  }
  return all;
};

// True when the picked concerns include a conflicting pair (e.g. low_supply+wean).
export const hasConflict = (primary, related = []) => {
  const set = new Set([primary, ...(related || [])].filter(Boolean));
  return CONFLICT_PAIRS.some(([a, b]) => set.has(a) && set.has(b));
};

// Build the list of follow-up questions to ASK, deduplicating by `dedup_key`
// across concerns AND filtering out questions whose `condition(answers)`
// predicate returns false against the current answer state. Returns
// [{ cid, q, mirrors: [{cid, qid}, ...] }]. When the user answers a deduped
// question, the answer is propagated to every concern listed in `mirrors`.
export const buildDedupedFollowups = (concernIds, concernFollowups = {}) => {
  const seen = new Map(); // dedup_key -> index in `out`
  const out = [];
  for (const cid of concernIds) {
    const def = CONCERN_FOLLOWUPS[cid];
    if (!def) continue;
    for (const q of def.questions) {
      // Skip the question entirely if its condition (evaluated against THIS
      // concern's current answers) returns false.
      if (typeof q.condition === 'function') {
        try {
          if (!q.condition(concernFollowups[cid] || {})) continue;
        } catch { continue; }
      }
      const key = q.dedup_key || `${cid}:${q.id}`;
      if (seen.has(key)) {
        out[seen.get(key)].mirrors.push({ cid, qid: q.id });
        continue;
      }
      seen.set(key, out.length);
      out.push({ cid, q, mirrors: [] });
    }
  }
  return out;
};

// ===========================================================================
// Combined Summary + Priority Plan
// ===========================================================================
// When picking primary + related concerns we render a short top-of-page block
// that explains how the concerns may be connected and gives a numbered priority
// action order. Keyed by a sorted unordered combination of concern ids so the
// same plan applies regardless of which one the user picked as primary.
//
// Falls back to the primary concern's first 3-4 action steps when no specific
// combo exists.

const _comboKey = (ids) => [...ids].sort().join('+');

export const COMBINED_PLANS = {
  // engorgement + latch difficulty (very common postpartum days 3-5)
  [_comboKey(['engorgement', 'latch'])]: {
    summary_zh: '你目前像是产后初期的生理性涨奶，加上宝宝含乳困难。乳晕变硬通常会让宝宝更难含上，含乳不顺则进一步影响奶水移出，所以两个问题会互相影响。',
    summary_en: 'This looks like early physiological engorgement combined with latch difficulty. A hard areola makes latching harder, and a poor latch makes milk removal harder — the two reinforce each other.',
    priority_zh: [
      '先用手挤几分钟，把乳晕软化',
      '再尝试正确的含乳姿势（tummy to tummy、宝宝下巴先靠近乳房）',
      '如果宝宝仍含不上，每 2-3 小时手挤或低吸力挤奶一次',
      '亲喂/挤奶后冷敷 10-15 分钟',
      '观察 1-2 天；若无改善预约泌乳指导',
    ],
    priority_en: [
      'Hand express for a few minutes to soften the areola first',
      'Then try a correct latch (tummy to tummy, chin to breast first)',
      'If baby still cannot latch, hand express or pump at low suction every 2-3 hours',
      'Apply cold compress for 10-15 minutes after milk removal',
      'Observe for 1-2 days; book lactation support if no improvement',
    ],
  },
  // clog + white spot (very common pair)
  [_comboKey(['clog', 'white_spot'])]: {
    summary_zh: '小白点常常会让后方的乳汁排不出来，进而出现堵奶硬块。两者一起处理，重点是先打开乳头出口，再温和地把乳房的奶水移出。',
    summary_en: 'A nipple bleb often traps milk behind it, which can quickly cause a clogged duct. Open the nipple opening first, then move milk gently — do not push hard on the lump.',
    priority_zh: [
      'Epsom salt + Haakaa 浸泡 10-15 分钟，舒缓乳头出口',
      '让宝宝吸不舒服那边，宝宝吸吮通常比挤奶器更有效',
      '挤奶后加 15 分钟手挤奶，重点放在乳头和乳晕',
      '不要用力按压硬块，挤完后冷敷',
      '反复出现可咨询医生关于 sunflower lecithin',
    ],
    priority_en: [
      'Epsom salt + Haakaa soak for 10-15 minutes to ease the nipple opening',
      'Offer the affected side to baby — suckling is often more effective than a pump',
      'After pumping, add 15 minutes of hand expression focused on the nipple and areola',
      'Do not press hard on the lump; apply cold compress afterwards',
      'If it keeps recurring, ask your doctor whether sunflower lecithin is suitable',
    ],
  },
  // nipple_pain + latch (latch is the likely root cause)
  [_comboKey(['nipple_pain', 'latch'])]: {
    summary_zh: '乳头疼痛和含乳困难同时出现时，含乳方式通常就是疼痛的根本原因。先把含乳调整好，乳头压力下降，疼痛通常会跟着减轻。',
    summary_en: 'Nipple pain together with latch difficulty usually means the latch itself is the root cause of the pain. Fix positioning first; once pressure on the nipple drops, pain usually eases too.',
    priority_zh: [
      '让宝宝身体贴近妈妈，tummy to tummy',
      '乳头对准宝宝鼻子或上唇，等宝宝张大嘴',
      '宝宝下巴先靠近乳房，确保深含乳',
      '如果乳房太硬，先手挤一点奶让乳晕变软',
      '观察尿布、吞咽声、体重，若怀疑舌系带或宝宝喝不够请预约评估',
    ],
    priority_en: [
      'Bring baby close, tummy to tummy',
      'Aim nipple toward baby\u2019s nose or upper lip; wait for a wide-open mouth',
      'Let baby\u2019s chin touch the breast first to support a deeper latch',
      'If the breast feels too hard, hand express a little to soften the areola',
      'Track wet diapers, swallowing, weight — book an assessment if tongue tie or poor intake is suspected',
    ],
  },
  // low_supply + work_pump
  [_comboKey(['low_supply', 'work_pump'])]: {
    summary_zh: '回职场前担心奶量是非常常见的。重点不是马上猛追奶，而是先确认乳房是否通畅、含乳/挤奶是否有效，再循序渐进调整上班节奏。',
    summary_en: 'Worrying about supply before returning to work is very common. The priority is not aggressive boosting first — check that milk can flow well and that latch/pumping is effective, then transition the schedule gradually.',
    priority_zh: [
      '先排除堵奶、含乳问题或喇叭尺寸不合',
      '建立一天 6-8 次排奶（亲喂+挤奶混合）的稳定节奏',
      '上班前 1-2 周慢慢把间隔从 3 小时拉到 3.5-4 小时',
      '在工作时间内至少安排 1-2 次挤奶',
      '看 3 天奶量趋势，不要被单次结果影响心情',
    ],
    priority_en: [
      'First rule out blocked flow, latch issues, or wrong flange size',
      'Build a steady rhythm of 6-8 milk removals/day (latch + pump mix)',
      'In the 1-2 weeks before work, stretch intervals from 3h to 3.5-4h',
      'Plan at least 1-2 pumping sessions during the workday',
      'Look at a 3-day supply trend rather than single-session output',
    ],
  },
  // low_supply + latch
  [_comboKey(['low_supply', 'latch'])]: {
    summary_zh: '宝宝含乳/吸吮效率不好会直接影响奶量。在加催奶前，先确认乳汁可以顺利移出比较重要。',
    summary_en: 'When latch or sucking efficiency is poor, milk removal suffers and supply drops. Make sure milk can actually flow before trying to boost supply.',
    priority_zh: [
      '先调整含乳姿势，确认宝宝有深含乳',
      '亲喂后若乳房还胀，加手挤或低吸力挤奶',
      '一天目标 8-12 次有效的乳汁移出',
      '观察尿布、吞咽声、体重 3 天再判断奶量',
      '若怀疑舌系带或宝宝喝不够，请预约评估',
    ],
    priority_en: [
      'Fix the latch first; make sure baby gets a deep latch',
      'If the breast still feels full after latch, add hand expression or low-suction pumping',
      'Aim for 8-12 effective milk removals per day',
      'Track wet diapers, swallowing, weight for 3 days before judging supply',
      'Book an assessment if tongue tie or poor intake is suspected',
    ],
  },
  // weaning + engorgement + blocked duct
  [_comboKey(['clog', 'engorgement', 'wean'])]: {
    summary_zh: '你正在考虑退奶 / 减少奶量，同时有胀硬和硬块。现在不适合突然停挤或继续拉长太快，应该先让乳汁维持流动、排到舒服，再慢慢减少频率。',
    summary_en: 'You are trying to reduce supply while also having fullness and a lump. This is not the right time to suddenly stop or stretch intervals too quickly. First keep milk flowing enough for comfort, then reduce gradually.',
    priority_zh: [
      '不要突然停掉所有亲喂或挤奶',
      '回到较短间隔，每次排到舒服即可',
      '硬块处加 15 分钟手挤，重点放在乳头和乳晕；不要用力按',
      '排奶后冷敷 10-15 分钟',
      '稳定 3-5 天没有硬块再慢慢拉长',
      '若发烧、红肿或硬块不退，请尽快咨询',
    ],
    priority_en: [
      'Do not suddenly stop nursing or pumping',
      'Return to a shorter interval and express only until comfortable',
      'Add 15 minutes of hand expression on the affected side (focus on nipple/areola) — no forceful pressing',
      'Apply cold compress for 10-15 minutes after milk removal',
      'Stabilise for 3-5 days without lumps before stretching the interval again',
      'Seek help promptly if fever, redness, or persistent lump appears',
    ],
  },
  // weaning + engorgement (no lump)
  [_comboKey(['engorgement', 'wean'])]: {
    summary_zh: '退奶过程中的胀硬，是身体在告诉你减少得太快。先排到舒服，再慢慢拉长时间，比硬撑或直接停掉安全。',
    summary_en: 'Fullness while weaning is your body saying "you stretched too fast". Expressing until comfortable and stretching the interval gradually is safer than pushing through or stopping suddenly.',
    priority_zh: [
      '回到较短间隔，让乳房恢复舒适',
      '每次只排到舒服，不需要排空',
      '挤奶后冷敷 10-15 分钟',
      '减少汤水和发奶食物 / milk booster',
      '稳定 3-5 天后再慢慢拉长',
    ],
    priority_en: [
      'Return to a shorter interval until the breast feels comfortable',
      'Express only until comfortable — do not empty',
      'Apply cold compress for 10-15 minutes after milk removal',
      'Reduce heavy soups and milk boosters',
      'Stabilise for 3-5 days before stretching the interval again',
    ],
  },
  // low_supply + weaning with goal=wean
  [_comboKey(['low_supply', 'wean']) + '|goal:wean']: {
    summary_zh: '你确认的目标是减少奶量，所以结果会以安全退奶和减少压力为主，不会给追奶或催奶建议。',
    summary_en: 'You confirmed that your goal is to reduce supply, so this result focuses on safe weaning and reducing pressure — milk boosting is not recommended.',
    priority_zh: [
      '以舒适为优先，不需要把奶量追回来',
      '慢慢拉长亲喂 / 挤奶间隔',
      '每次只排到舒服，不要排空',
      '避免 milk booster 和大量发奶食物',
      '出现胀痛或硬块时，先回到较短间隔',
    ],
    priority_en: [
      'Prioritise comfort; do not try to push supply back up',
      'Gradually stretch the nursing / pumping interval',
      'Express only until comfortable; do not empty',
      'Avoid milk boosters and heavy lactogenic foods',
      'If fullness or a lump appears, return to a shorter interval first',
    ],
  },
  // mastitis + low_supply
  [_comboKey(['low_supply', 'mastitis'])]: {
    summary_zh: '发炎或堵奶期间奶量下降可能是暂时的。现在优先是处理发烧 / 红肿风险、维持乳汁流动，再观察恢复后的奶量。',
    summary_en: 'Milk output may drop temporarily during inflammation or blocked flow. The priority is to manage fever/redness risk, keep milk moving, and reassess supply after recovery.',
    priority_zh: [
      '先依照乳腺炎卡片处理：必要时就医、规律排奶、不要做剧烈按摩',
      '冷敷舒缓肿胀和疼痛',
      '不要在发炎期间加大量 milk booster 或催奶食物',
      '恢复 3-7 天后再评估奶量',
      '若奶量没有回升，再考虑结构化的追奶计划',
    ],
    priority_en: [
      'Follow the mastitis card first: seek a doctor if needed, keep removing milk regularly, avoid forceful massage',
      'Use cold compress to ease swelling and pain',
      'Do not add heavy milk boosters or lactogenic foods during inflammation',
      'Re-assess supply 3-7 days after recovery',
      'Only consider a structured boosting plan if supply does not recover',
    ],
  },
  // low_supply + pump_issue
  [_comboKey(['low_supply', 'pump_issue'])]: {
    summary_zh: '奶量下降也可能和挤奶器、喇叭尺寸或吸力有关。先检查排奶工具是否合适，再决定是否需要追奶。',
    summary_en: 'Lower output may be related to pump setup, flange size, or suction. Check milk-removal tools first before deciding whether supply boosting is needed.',
    priority_zh: [
      '参考挤奶器卡片，重新量乳头尺寸',
      '检查配件、阀门、膜片是否装好',
      '初期使用按摩模式 + 低吸力 level 1-2',
      '挤奶 20-30 分钟，必要时加手挤辅助',
      '调整 3-7 天再看奶量趋势',
    ],
    priority_en: [
      'See the pump card and re-measure your nipple size',
      'Check parts, valves, and membranes for fit and damage',
      'Start with massage mode + low suction (level 1-2)',
      'Pump for 20-30 minutes, add hand expression if needed',
      'Re-assess supply trend 3-7 days after adjustments',
    ],
  },
  // mastitis + low_supply + pump_issue
  [_comboKey(['low_supply', 'mastitis', 'pump_issue'])]: {
    summary_zh: '发炎风险加上排奶工具问题，会让奶量短时间内明显下降。先处理发炎和流动，再检查挤奶器，最后再评估是否需要追奶。',
    summary_en: 'Inflammation risk plus pump-setup issues can drop output sharply in the short term. Treat the inflammation and milk flow first, fix the pump setup next, and only re-assess supply afterwards.',
    priority_zh: [
      '先依照乳腺炎卡片处理，需要就医时尽快就医',
      '继续规律排奶，避免完全不排',
      '检查挤奶器配件、喇叭尺寸和吸力',
      '不要在发炎期间使用大量 milk booster',
      '恢复 3-7 天后再看奶量是否回升',
    ],
    priority_en: [
      'Manage the mastitis risk first; see a doctor when appropriate',
      'Keep removing milk regularly — do not stop',
      'Verify pump parts, flange size, and suction',
      'Avoid heavy milk boosters while inflamed',
      'Re-assess supply 3-7 days after recovery',
    ],
  },
};

// Get the combined plan for a set of concerns, optionally biased by the
// user's confirmed goal (e.g. low_supply+wean has a different plan when goal
// is "wean" vs "increase"). Returns null when no special-cased plan exists.
export const getCombinedPlan = (concernIds, goal) => {
  if (!concernIds || concernIds.length < 2) return null;
  const base = _comboKey(concernIds);
  if (goal) {
    const keyed = COMBINED_PLANS[`${base}|goal:${goal}`];
    if (keyed) return keyed;
  }
  return COMBINED_PLANS[base] || null;
};

// Context note shown inside a concern card when the primary card already
// covers the likely root cause. e.g. nipple_pain card when `latch` is selected.
export const CONTEXT_NOTES = {
  // Key = `${this_concern}|${other_concern_also_selected}`
  'nipple_pain|latch': {
    zh: '你也选择了"含乳/亲喂问题"。乳头痛常常是含乳方式造成的，请优先看含乳卡片中的姿势建议。',
    en: 'You also picked "Latch / direct feeding". Nipple pain is often caused by the latch itself — see the latch card below for positioning fixes.',
  },
  'low_supply|latch': {
    zh: '你也选择了"含乳/亲喂问题"。含乳效率不好会直接影响奶量，请先看含乳卡片的建议。',
    en: 'You also picked "Latch / direct feeding". Poor latch is a common cause of low output — see the latch card for positioning fixes.',
  },
  'low_supply|pump_issue': {
    zh: '你也选择了"挤奶器/喇叭尺寸问题"。请先看挤奶器卡片中的尺寸和吸力建议。',
    en: 'You also picked "Pump / flange-size issue". Start with the pump-fit recommendations in the pump card.',
  },
  'engorgement|latch': {
    zh: '你也选择了"含乳/亲喂问题"。乳晕变硬会让宝宝更难含上，先用手挤软化乳晕再尝试含乳。',
    en: 'You also picked "Latch / direct feeding". A hard areola makes latching harder — hand express to soften it first, then latch.',
  },
};

export const getContextNote = (cid, otherIds, lang) => {
  for (const other of otherIds || []) {
    const note = CONTEXT_NOTES[`${cid}|${other}`];
    if (note) return lang === 'zh' ? note.zh : note.en;
  }
  return null;
};

// ===========================================================================
// Context-aware concern card variants
// ===========================================================================
// Some concerns need very different content depending on the *combination* of
// other selected concerns, the user's confirmed goal, and postpartum age.
// `resolveConcernResult(cid, submission)` returns the right variant.

export const CONCERN_RESULT_VARIANTS = {
  // Nipple pain when latch is also selected — latch is the likely root cause.
  nipple_pain_latch: {
    title_zh: '你的乳头疼痛很可能和含乳方式有关',
    title_en: 'Your nipple pain is most likely caused by the latch',
    why_zh: '当乳头疼痛和含乳困难一起出现时，疼痛大多是含乳方式造成的：含乳太浅、宝宝没有含到足够的乳晕、宝宝压迫或拉扯乳头、亲喂时滑出/咯咯声/哭闹，都会持续刺激乳头。先把含乳调整好，乳头压力降低，疼痛通常会跟着减轻。',
    why_en: 'When nipple pain comes together with latch difficulty, the latch itself is usually the cause: shallow latch, not enough areola in baby\u2019s mouth, baby compressing or pulling the nipple, slipping, clicking, or fussing at the breast all keep irritating the nipple. Fix the latch first and the pain usually eases.',
    what_to_do_zh: [
      '让宝宝身体贴近妈妈，tummy to tummy',
      '乳头对准宝宝鼻子或上唇，等宝宝张大嘴',
      '宝宝下巴先碰到乳房，确保含到深层乳晕，不只是乳头',
      '如果乳房太硬，先手挤一点奶让乳晕变软再含',
      '观察吞咽声、尿布、体重和宝宝精神，确认有效吸吮',
      '如果怀疑舌系带、体重不增或宝宝喝不够，请预约专业泌乳评估',
    ],
    what_to_do_en: [
      'Bring baby close, tummy to tummy',
      'Aim nipple toward baby\u2019s nose or upper lip; wait for a wide-open mouth',
      'Let baby\u2019s chin touch the breast first so the latch is deep (areola, not just nipple)',
      'If the breast feels too hard, hand express a little to soften the areola before latching',
      'Track swallowing, wet diapers, weight, and baby alertness to confirm effective sucking',
      'If tongue tie, poor weight gain, or poor intake is suspected, book a professional latch assessment',
    ],
    observe_zh: [
      '含乳调整后通常 1-3 天疼痛会下降，若几天后还是痛，请预约评估。',
      '亲喂时若听到清脆吞咽声、乳房变软、宝宝喂后比较满足，代表含乳更有效。',
    ],
    observe_en: [
      'After fixing the latch, pain usually eases within 1-3 days. If it persists, book an assessment.',
      'If you hear clear swallowing, feel the breast soften, and baby seems more settled after feeding, the latch is more effective.',
    ],
    when_to_seek_zh: ['如果乳头持续破皮流血、宝宝拒喝、尿布明显减少、嗜睡，或妈妈有发烧/红肿，请尽快咨询医生或专业泌乳顾问。'],
    when_to_seek_en: ['Seek help promptly if nipples remain cracked or bleeding, baby refuses feeds, has fewer wet diapers or is unusually sleepy, or if mother develops fever or spreading redness.'],
  },

  // Engorgement during weaning (postpartum is past the day 3-5 hormonal phase).
  engorgement_weaning: {
    title_zh: '退奶过程中乳房胀硬，需要慢慢调整',
    title_en: 'Breast fullness during weaning needs gradual adjustment',
    why_zh: '退奶或减少挤奶时，乳房一下子太满，容易胀痛、硬块或堵奶。这种胀硬不是要追奶，而是提醒你减少得太快，需要先排到舒服，再慢慢拉长时间。',
    why_en: 'When reducing nursing or pumping, the breast can quickly become too full and develop fullness, lumps, or blocked flow. This is not a sign to boost supply — it tells you that you are stretching the interval too fast. Express until comfortable first, then lengthen the interval more gradually.',
    what_to_do_zh: [
      '不要突然停掉所有亲喂 / 挤奶',
      '每次只排到舒服，不需要挤到很空',
      '如果有硬块或明显胀痛，先回到较短的间隔',
      '排奶后冷敷 10-15 分钟',
      '等 3-5 天稳定后，再慢慢拉长时间',
      '如果发烧、红肿或硬块不退，请尽快咨询',
    ],
    what_to_do_en: [
      'Do not suddenly stop all nursing or pumping',
      'Express only until comfortable; do not aim to empty the breast',
      'If there is a lump or strong pain, return to a shorter interval first',
      'Apply cold compress for 10-15 minutes after milk removal',
      'Wait 3-5 days of stability before stretching the interval again',
      'Seek help promptly if you develop fever, spreading redness, or a lump that does not improve',
    ],
    when_to_seek_zh: ['退奶过程中出现发烧、寒颤、红肿扩散、剧烈疼痛或硬块不退，请尽快就医。'],
    when_to_seek_en: ['Seek medical care urgently if you develop fever, chills, spreading redness, severe pain, or a lump that does not improve while weaning.'],
  },

  // Low supply with goal=wean (mother confirmed reducing supply is the goal).
  low_supply_wean_goal: {
    title_zh: '你目前的目标是减少奶量，不需要追奶',
    title_en: 'Your current goal is to reduce supply, so milk boosting is not needed',
    why_zh: '你原本选择了奶量少，但你确认的目标是退奶 / 减少奶量，所以系统会以减少压力和安全退奶为主，不会建议追奶或催奶。',
    why_en: 'You originally picked "low supply", but you confirmed that your goal is to wean or reduce supply. The plan below focuses on safe weaning and reducing pressure — milk-boosting is intentionally NOT recommended here.',
    what_to_do_zh: [
      '以舒适为目标，不需要把奶量追回来',
      '如果乳房会涨，只排到舒服，不要完全排空',
      '慢慢拉长亲喂 / 挤奶间隔',
      '避免 milk booster 和明显发奶食物（如大量汤水、催奶补品）',
      '如果你其实是想保留一部分母乳但减少压力，可以选择混合喂养目标',
    ],
    what_to_do_en: [
      'Aim for comfort, not for higher supply',
      'If the breast feels full, express only until comfortable; do not empty fully',
      'Gradually lengthen the interval between feeds/pumps',
      'Avoid milk boosters and clearly lactogenic foods (heavy soups, lactation supplements)',
      'If you actually want to keep some breastfeeding while reducing pressure, switch your goal to mixed feeding',
    ],
    when_to_seek_zh: ['如果出现发烧、红肿扩散、硬块不退或乳房剧烈疼痛，请尽快咨询医生或泌乳顾问。'],
    when_to_seek_en: ['Seek help promptly if you develop fever, spreading redness, a persistent lump, or severe breast pain while reducing supply.'],
  },

  // Low supply with goal=maintain (mother just wants comfortable mixed feeding).
  low_supply_maintain_goal: {
    title_zh: '你的目标是维持现状，不需要积极追奶',
    title_en: 'Your goal is to maintain — aggressive boosting is not needed',
    why_zh: '你确认希望维持目前的奶量，所以重点是保护舒适、避免涨奶或堵奶，可以接受混合喂养，不需要积极追奶。',
    why_en: 'You confirmed that you want to maintain your current supply. The focus is on protecting comfort, avoiding engorgement or blockages, and accepting mixed feeding — aggressive supply boosting is not the goal.',
    what_to_do_zh: [
      '维持目前每天的亲喂 + 挤奶节奏',
      '如果乳房涨，多挤一点；如果舒服，不需要勉强排空',
      '观察 3 天的奶量趋势，单次结果不要影响信心',
      '不需要 power pumping 或大量 milk booster',
      '若你想增加或减少奶量，可咨询泌乳顾问设计一个温和的调整计划',
    ],
    what_to_do_en: [
      'Keep your current nursing + pumping rhythm steady',
      'If the breast feels full, remove a bit more; if comfortable, do not force-empty',
      'Look at a 3-day supply trend rather than single-session output',
      'Power pumping and heavy milk boosters are not needed for maintenance',
      'If you decide later to increase or reduce, a consultant can design a gentle adjustment plan',
    ],
  },

  // Low supply when mastitis is also selected — inflammation-related drop.
  low_supply_inflammation: {
    title_zh: '发炎 / 堵奶期间奶量下降可能是暂时的',
    title_en: 'A supply drop during inflammation or blocked flow may be temporary',
    why_zh: '当乳房发炎或堵奶时，乳汁排出受影响，奶量看起来会下降。这通常是暂时的，恢复后会改善。现在的重点不是催奶，而是处理发炎风险、维持乳汁流动。',
    why_en: 'When the breast is inflamed or milk flow is blocked, milk removal suffers and output looks lower. This is usually temporary and improves after recovery. The priority is NOT to boost supply now — it is to manage the inflammation risk and keep milk moving.',
    what_to_do_zh: [
      '先处理发炎风险（参考上方乳腺炎卡片）',
      '继续规律排奶，避免完全不排',
      '不要在发炎期间大量使用 milk booster 或发奶食物',
      '使用冷敷舒缓肿胀和疼痛',
      '恢复 3-7 天后再重新评估奶量趋势',
      '若奶量没有回升，再考虑系统性的追奶计划',
    ],
    what_to_do_en: [
      'Address the inflammation risk first (see the mastitis card above)',
      'Continue removing milk regularly — do not stop',
      'Avoid heavy milk boosters or lactogenic foods during inflammation',
      'Use cold compress to ease swelling and pain',
      'Re-assess supply trend 3-7 days after recovery',
      'Only consider a structured boosting plan if output does not recover',
    ],
  },

  // Low supply when pump_issue is also selected, OR subtype=after_pump_change.
  low_supply_pump: {
    title_zh: '你的奶量下降可能和挤奶器 / 喇叭尺寸有关',
    title_en: 'Your supply drop may be related to pump or flange-size issues',
    why_zh: '不合适的喇叭尺寸、太强或太弱吸力，或配件没装好，都可能让排奶不彻底，看起来像奶量下降。先确认排奶工具是否合适，再决定是否需要追奶。',
    why_en: 'A wrong flange size, suction that is too strong or too weak, or poorly assembled parts can leave the breast under-drained — output looks lower than supply. Verify that your milk-removal setup is right before deciding whether boosting is needed.',
    what_to_do_zh: [
      '参考挤奶器 / 喇叭尺寸卡片，重新量乳头尺寸',
      '配件 / 阀门 / 膜片要装好、没有损坏',
      '初期建议从按摩模式、低吸力 level 1-2 开始',
      '每次挤奶 20-30 分钟即可，不必硬撑很久',
      '挤奶 + 手挤的混合方式通常排空更好',
      '调整 3-7 天后再看奶量趋势',
    ],
    what_to_do_en: [
      'See the pump/flange card and re-measure your nipple size',
      'Verify parts/valves/membranes are properly fitted and not damaged',
      'Start with massage mode and low suction (level 1-2)',
      'Pumping 20-30 minutes per session is enough — longer does not always mean more',
      'A pump + hand-expression combo usually drains better',
      'Re-assess supply trend 3-7 days after adjustments',
    ],
  },

  // Low supply when subtype indicates a blockage-related sudden drop.
  low_supply_blockage_drop: {
    title_zh: '奶量突然下降，请先检查堵奶 / 发炎 / 工具问题',
    title_en: 'Sudden output drop — check for blocked flow, inflammation, or tool issues first',
    why_zh: '奶量突然下降时，要先检查堵奶、发炎、泵和喇叭问题，不要马上催奶。处理好流动问题，奶量通常会自己回来一部分。',
    why_en: 'When milk output suddenly drops, check for blocked flow, inflammation, pump, and flange issues first — do not jump to milk boosting. Once flow improves, output often recovers on its own.',
    what_to_do_zh: [
      '检查乳房是否有硬块或疼痛区域',
      '检查挤奶器配件、喇叭尺寸、吸力是否合适',
      '继续规律亲喂 + 挤奶，让乳汁维持流动',
      '不要立刻使用大量 milk booster',
      '观察 3-5 天，看奶量是否随着流动改善慢慢回升',
      '若有发烧或红肿，请尽快就医',
    ],
    what_to_do_en: [
      'Check the breast for lumps or painful areas',
      'Check pump parts, flange size, and suction',
      'Keep nursing and pumping regularly so milk continues to flow',
      'Do not jump to heavy milk boosters yet',
      'Observe over 3-5 days as flow improves',
      'Seek medical care if you develop fever or spreading redness',
    ],
  },
  // Engorgement past day 7 with blockage/inflammation signals (clog, white_spot,
  // mastitis, or postpartum already past the day 3-5 hormonal phase). This
  // explicitly REPLACES the "early physiological engorgement" framing so we
  // don't mislabel a blocked-flow swelling as a hormonal phenomenon.
  engorgement_blocked_flow: {
    title_zh: '乳房胀硬可能和局部乳汁排出不顺有关',
    title_en: 'Breast fullness may be related to blocked milk flow',
    why_zh: '你目前已经超过产后初期，加上有硬块、小白点或局部疼痛，这次乳房胀硬比较可能和乳汁排出不顺有关，而不是生理性涨奶。建议先处理堵塞原因、维持温和排奶，并观察硬块和疼痛是否改善。',
    why_en: 'You are past the early postpartum stage, and the lump, nipple bleb, or local pain suggests that this breast fullness is more likely related to poor milk flow rather than physiological engorgement. Focus on the cause of the blockage, maintain gentle milk removal, and monitor the lump and pain.',
    what_to_do_zh: [
      '继续规律排奶，不要突然停奶或拉得太久',
      '检查挤奶器配件、阀门 / 膜片是否装好、损坏或不合适',
      '挤奶后加 15 分钟手挤奶，重点放在乳头和乳晕；硬块只需另一只手轻轻支撑，不要大力按压',
      '如果宝宝愿意亲喂，多让宝宝吸，吸吮通常比挤奶器更有效',
      '排奶后冷敷 10-15 分钟，不建议持续温敷',
      '如果有小白点，可参考 Epsom salt 浸泡 + 手挤奶教学',
    ],
    what_to_do_en: [
      'Keep milk removal regular; do not suddenly stop or stretch the interval too long',
      'Check pump parts, valves, and membranes for fit and damage',
      'After pumping, add 15 minutes of hand expression focused on the nipple/areola; just gently support the lump with the other hand — do not press hard',
      'If baby will latch, offer the affected side — baby is often more effective than a pump',
      'Apply cold compress for 10-15 minutes after milk removal; avoid continuous heat',
      'If a nipple bleb is present, see the Epsom salt soak + hand expression guides',
    ],
    observe_zh: [
      '如果硬块在 24 小时内变小、疼痛下降，通常方向正确。',
      '如果奶量某一边突然下降，也要同时检查泵和喇叭，不一定只是少奶。',
    ],
    observe_en: [
      'If the lump becomes smaller and pain reduces within 24 hours, the plan is likely helping.',
      'If milk output suddenly drops on one side, also check the pump and flange — it is not always true low supply.',
    ],
    when_to_seek_zh: ['出现发烧、寒颤、红肿扩散、剧烈疼痛或硬块不退，请尽快咨询医生或泌乳顾问。'],
    when_to_seek_en: ['Seek care promptly if you develop fever, chills, spreading redness, severe pain, or a lump that does not improve.'],
  },

  // Low supply that was low from birth OR did not rise after week 2 — focus on
  // ESTABLISHING supply rather than treating a "drop".
  low_supply_establish: {
    title_zh: '你的奶量从一开始就比较少，需要建立奶量',
    title_en: 'Your supply has been low from the start — focus on establishing supply',
    why_zh: '当奶量从产后初期就偏少，或第二周以后还没有明显增加时，重点不是"追回掉下来的奶量"，而是建立一个稳定的奶量基础。常见的关键点是：含乳是否够深、乳汁是否有效移出、排奶次数是否够、挤奶器和喇叭是否合适。',
    why_en: 'When supply has been low since the early postpartum days, or has not risen by week two, the focus is not on "getting back" lost supply — it is on building a stable baseline. Key levers: depth of latch, effective milk removal, frequency of milk removal, and pump/flange fit.',
    what_to_do_zh: [
      '检查含乳：tummy to tummy、宝宝下巴先靠近乳房、含到乳晕不只是乳头',
      '检查挤奶器和喇叭尺寸；初期用按摩模式 + 低吸力 level 1-2',
      '维持一天 8-12 次排奶（亲喂 + 挤奶），夜间至少一次',
      '每次亲喂或挤奶之后加几分钟手挤，帮助排空',
      '记录 3 天的奶量（milk log）观察趋势，不要只看单次结果',
      '排除堵奶 / 发炎再考虑 power pumping（产后 1 周后，连续 7 晚 11pm-2am 之间）',
      'Milk booster 是辅助，不能取代上面的关键点',
    ],
    what_to_do_en: [
      'Check the latch: tummy to tummy, chin to breast first, mouth covering the areola — not just the nipple',
      'Check pump and flange fit; early on, use massage mode and low suction level 1-2',
      'Aim for 8-12 milk removals per day (latch + pump combined), at least one overnight',
      'Add a few minutes of hand expression after each nursing/pumping session',
      'Log 3 days of output (milk log) and look at the trend, not single sessions',
      'Rule out blocked flow and inflammation before adding power pumping (after week 1, 7 nights between 11pm-2am)',
      'Milk boosters are optional support — they do not replace the steps above',
    ],
    observe_zh: [
      '一天 6-8 片湿尿布、宝宝有规律吞咽声、体重增长正常，通常代表摄入足够',
      '若 3-5 天没有改善，建议预约泌乳评估（不是马上换配方奶）',
    ],
    observe_en: [
      '6-8 wet diapers/day, rhythmic swallowing, and normal weight gain usually indicate adequate intake',
      'If there is no improvement after 3-5 days, book a supply assessment (do not jump straight to formula)',
    ],
    when_to_seek_zh: ['如果宝宝尿量明显减少、嗜睡、拒喝、体重不增或黄疸加重，请尽快咨询医生或泌乳顾问。'],
    when_to_seek_en: ['Seek help promptly if baby has fewer wet diapers, is unusually sleepy, refuses feeds, has poor weight gain, or worsening jaundice.'],
  },

  // Low supply with a clear gradual decrease (onset=gradually_decreased).
  low_supply_gradual: {
    title_zh: '奶量逐渐下降，可以一步步重建',
    title_en: 'Gradual supply decrease — can be rebuilt step by step',
    why_zh: '奶量逐渐变少，常见原因包括排奶次数减少、亲喂或挤奶间隔变长、回职场后节奏改变、休息不足、压力大、或挤奶器效率下降。这不是突然出问题，所以重建也可以一步步来。',
    why_en: 'A gradual decrease usually comes from fewer milk removals, longer intervals, a different work schedule, fatigue, stress, or reduced pump efficiency. It did not appear suddenly, so rebuilding can also be gradual.',
    what_to_do_zh: [
      '回顾一天有几次有效排奶；目标先回到 6-8 次',
      '检查间隔：白天尽量不超过 4 小时',
      '检查挤奶器配件、阀门、膜片、喇叭尺寸',
      '亲喂效率是否下降？必要时配合挤奶或手挤',
      '如果体力允许，可加 3-7 天的 power pumping（前提是没有堵奶 / 发炎）',
      'Milk booster 是辅助；优先排奶频率、含乳和工具',
    ],
    what_to_do_en: [
      'Count how many effective milk removals you do per day — aim back at 6-8',
      'Check intervals: try not to exceed 4 hours during the daytime',
      'Check pump parts, valves, membranes, and flange fit',
      'If direct-latch efficiency has dropped, add pumping or hand expression',
      'If you have the energy, add 3-7 days of power pumping (only when no blockage/inflammation)',
      'Milk boosters are optional support — prioritise frequency, latch, and tools',
    ],
    observe_zh: ['用 3 天的 milk log 看趋势；单次结果不要影响判断。'],
    observe_en: ['Look at a 3-day milk-log trend; do not let a single session shift your judgement.'],
  },

  // Two-stage variant: when low_supply + pump_issue are picked together WITHOUT
  // a blockage / inflammation / sudden-drop signal. Keeps supply-building advice
  // instead of becoming a duplicate pump-only card.
  low_supply_pump_two_stage: {
    title_zh: '先修正排奶工具，再决定要不要追奶（两阶段计划）',
    title_en: 'Fix milk-removal tools first, then decide whether to boost supply (two-stage plan)',
    why_zh: '挤奶器、喇叭尺寸或吸力不合适会让乳汁排不彻底，看起来像奶量下降。比较安全的做法是先把排奶工具调整好，再观察 3-7 天奶量变化；如果工具修正后奶量还是低，再开始建立稳定追奶节奏。',
    why_en: 'When the pump, flange, or suction is not right, milk does not get removed fully — output looks lower than your actual supply. The safer approach is to fix the tool side first, observe 3-7 days, and only start a structured supply-building plan if output is still low afterwards.',
    what_to_do_zh: [
      '第一阶段：修正排奶工具',
      '• 参考挤奶器卡片，重新量乳头尺寸，选合适 flange / insert',
      '• 检查阀门 / 膜片是否装好或损坏',
      '• 初期使用按摩模式 + 低吸力 level 1-2',
      '• 每次挤奶 20-30 分钟，加手挤辅助排空',
      '第二阶段：观察 3-7 天，若奶量没有回升再追奶',
      '• 一天目标 6-8 次有效排奶',
      '• 排除堵奶 / 发炎后可加 power pumping',
      '• 用 milk log 看 3 天趋势',
      '• 必要时预约追奶 / 排奶评估',
    ],
    what_to_do_en: [
      'Stage 1 — fix milk-removal tools first',
      '• See the pump card; re-measure nipple size and choose the right flange/insert',
      '• Check valves and membranes for fit and damage',
      '• Start with massage mode + low suction level 1-2',
      '• Pump 20-30 minutes per session and add hand expression',
      'Stage 2 — observe 3-7 days; if output is still low, then start supply building',
      '• Aim for 6-8 effective milk removals per day',
      '• Once blockage/inflammation are ruled out, you may add power pumping',
      '• Use a 3-day milk-log trend',
      '• Book a supply / pumping assessment if needed',
    ],
    observe_zh: ['工具修正前不要立刻使用大量 milk booster；先把排奶基础打好，再考虑加辅助。'],
    observe_en: ['Do not jump to heavy milk boosters before tool correction; build the milk-removal foundation first, then consider adjuncts.'],
  },
};

// Resolve which content variant should render for a given concern on the
// combined result page. Returns the base CONCERN_RESULTS entry when no
// special-case applies.
//
// Priority order (highest first):
//   1. Mastitis / true Red flags
//   2. Blocked flow / hard lump / nipple bleb
//   3. Pump / flange effectiveness
//   4. Supply-building plan
export const resolveConcernResult = (cid, submission) => {
  if (!submission) return CONCERN_RESULTS[cid];
  const primary = submission.primary_concern || submission.main_concern;
  const related = Array.isArray(submission.related_concerns) ? submission.related_concerns : [];
  const allIds = [primary, ...related].filter(Boolean);
  const otherIds = allIds.filter((x) => x !== cid);
  const fu = submission.concern_followups || {};
  const ppa = submission.postpartum_age || '';
  const goal = submission.goal_confirmation;
  const lowSupplyAnswers = fu.low_supply || {};
  const onset = lowSupplyAnswers.low_supply_onset;
  const subtype = lowSupplyAnswers.drop_subtype;
  const earlyPostpartum = ppa === '0-3d' || ppa === '4-7d';
  // Any signal of blockage-related fullness (used by engorgement routing).
  const hasBlockageSignal = allIds.includes('clog')
    || allIds.includes('white_spot')
    || allIds.includes('mastitis');

  // nipple_pain → latch-first when latch is also selected and pump pain is NOT
  // explicitly reported. If pump_issue is selected OR pump-pain is yes, keep
  // the default pump-focused content.
  if (cid === 'nipple_pain') {
    const pumpPain = (fu.nipple_pain || {}).continuous === 'yes' && otherIds.includes('pump_issue');
    if (otherIds.includes('latch') && !otherIds.includes('pump_issue') && !pumpPain) {
      return CONCERN_RESULT_VARIANTS.nipple_pain_latch;
    }
  }

  // engorgement card priority cascade:
  //   • weaning context when wean is selected and postpartum is past 7 days
  //   • blocked-flow framing past day 7 OR when blockage signals are present
  //   • otherwise default "early physiological engorgement" (only valid 0-7d)
  if (cid === 'engorgement') {
    if (allIds.includes('wean') && !earlyPostpartum) {
      return CONCERN_RESULT_VARIANTS.engorgement_weaning;
    }
    if (!earlyPostpartum || hasBlockageSignal) {
      return CONCERN_RESULT_VARIANTS.engorgement_blocked_flow;
    }
    return CONCERN_RESULTS[cid];
  }

  // low_supply → ordered routing (priority: goal > mastitis > blockage > pump > supply-building)
  if (cid === 'low_supply') {
    // 1. Goal-confirmation overrides everything else
    if (goal === 'wean') return CONCERN_RESULT_VARIANTS.low_supply_wean_goal;
    if (goal === 'maintain') return CONCERN_RESULT_VARIANTS.low_supply_maintain_goal;

    // 2. Mastitis present → temporary-drop framing (no aggressive boosting)
    if (allIds.includes('mastitis')) return CONCERN_RESULT_VARIANTS.low_supply_inflammation;

    // 3. Active blocked-flow signals → flow-first framing
    if (subtype === 'sudden_one_side' || subtype === 'after_lump_pain' || allIds.includes('clog')) {
      return CONCERN_RESULT_VARIANTS.low_supply_blockage_drop;
    }

    // 4. Pump/flange-related signals:
    //    - When pump_issue is co-selected AND there's no blockage / sudden drop,
    //      use the two-stage variant that retains supply-building advice.
    //    - When subtype=after_pump_change without pump being co-selected, still
    //      use the pump-only framing as the explanation.
    if (allIds.includes('pump_issue')) return CONCERN_RESULT_VARIANTS.low_supply_pump_two_stage;
    if (subtype === 'after_pump_change') return CONCERN_RESULT_VARIANTS.low_supply_pump;

    // 5. Onset-based supply-building branches
    if (onset === 'low_from_start' || onset === 'not_increased_after_week_two') {
      return CONCERN_RESULT_VARIANTS.low_supply_establish;
    }
    if (onset === 'gradually_decreased') {
      return CONCERN_RESULT_VARIANTS.low_supply_gradual;
    }
    if (onset === 'suddenly_decreased') {
      return CONCERN_RESULT_VARIANTS.low_supply_blockage_drop;
    }
  }

  return CONCERN_RESULTS[cid];
};
